import { getLabel, getMetadata, getThumbnailId } from '../../2.x/iiif/descriptive';
import { getNavDate } from '../../2.x/iiif/technical';

var getSummary = function getSummary(resource) {
  return resource.summary || null;
};

var getRequiredStatement = function getRequiredStatement(resource) {
  return resource.requiredStatement || null;
};

var getRights = function getRights(resource) {
  return resource.rights || null;
};

var getPosterCanvas = function getPosterCanvas(resource) {
  return resource.posterCanvas || null;
};

var getLanguage = function getLanguage(resource) {
  return resource.language || null;
};

export { getLabel, getMetadata, getSummary, getThumbnailId, getPosterCanvas, getRequiredStatement, getRights, getNavDate, getLanguage };